<!-- Enter registration -->
<mat-card class="example-card">
    <mat-card-header>
        <mat-card-title>Registration</mat-card-title>
        <mat-card-subtitle>Enter you data</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <!-- input for login & pass -->
        <form class="example-form" action="/action_page.php">
            <table class="example-full-width" cellspacing="0">
                <tr>
                    <td>
                        <mat-form-field class="example-full-width">
                            <mat-label>Сreate a email</mat-label>
                            <input matInput #message maxlength="256" placeholder="Enter login" id="email" name="email"
                                [(ngModel)]="loginForm.cemail">
                            <mat-hint align="start"><strong>Don't disclose personal info</strong> </mat-hint>
                            <mat-hint align="end">{{message.value.length}} / 256</mat-hint>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <td>
                        <mat-form-field class="example-full-width">
                            <mat-label>Сreate a password</mat-label>
                            <input matInput #message maxlength="256" placeholder="Enter password" id="password"
                                name="password" [(ngModel)]="loginForm.cpassword">
                            <mat-hint align="start"><strong>Don't disclose personal info</strong> </mat-hint>
                            <mat-hint align="end">{{message.value.length}} / 256</mat-hint>
                        </mat-form-field>
                    </td>
                </tr>
            </table>
            <br>
            <button mat-raised-button color="accent" type="submit" (click)="regForm()">Registration</button>
        </form>

    </mat-card-content>
</mat-card>